import {
    localCalendarDateInputToUtcIsoEndOfDay,
    localCalendarDateInputToUtcIsoStartOfDay,
} from '../../shared/utils/local-calendar-date-to-utc-iso.util';
import {
    DWT_DEFRA_SUBMISSIONS_ACTIVITY,
    resolveDwtDefraSubmissionsRecordCount,
} from '../dwt-defra-submissions.constants';
import type {
    DwtDefraSubmissionsPayload,
    DwtDefraSubmissionsTaskPaneFilter,
    DwtDefraSubmissionsWireFilter,
} from '../models/dwt-defra-submissions.model';

function buildWireFilter(filter: DwtDefraSubmissionsTaskPaneFilter): DwtDefraSubmissionsWireFilter {
    const recordCount = resolveDwtDefraSubmissionsRecordCount(filter.recordCount);
    const startDate = filter.startDate?.trim() ?? '';
    const endDate = filter.endDate?.trim() ?? '';
    const createdOnFrom = startDate ? localCalendarDateInputToUtcIsoStartOfDay(startDate) : null;
    const createdOnTo = endDate ? localCalendarDateInputToUtcIsoEndOfDay(endDate) : null;

    const wire: DwtDefraSubmissionsWireFilter = {
        startIndex: 0,
        recordCount,
        facilityCode: [...filter.facilityCode],
        status: [...filter.status],
    };
    if (createdOnFrom) {
        wire.createdOnFrom = createdOnFrom;
    }
    if (createdOnTo) {
        wire.createdOnTo = createdOnTo;
    }
    return wire;
}

/** Builds the Activity Handler envelope from a filter object (pure — no DOM). */
export function buildDwtDefraSubmissionsPayloadFromFilter(
    filter: DwtDefraSubmissionsTaskPaneFilter
): DwtDefraSubmissionsPayload {
    return {
        activity: DWT_DEFRA_SUBMISSIONS_ACTIVITY,
        isAsync: false,
        data: { filters: buildWireFilter(filter) },
    };
}
